module.exports = __webpack_public_path__ + "img/logo_junta_andalucia_blanco.3b69632a.png";